import {
  Container,
  createStyles,
  rem,
  Text,
  Title as MantineTitle,
  Sx,
} from "@mantine/core";

interface Props {
  title: string;
  description: string;
  sx?: Sx;
}

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: rem(34),
    fontWeight: 900,
    color: theme.colors.yellow[4],

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(24),
    },
  },

  description: {
    maxWidth: 600,
    margin: "auto",

    "&::after": {
      content: '""',
      display: "block",
      backgroundColor: theme.colors.yellow[4],
      width: rem(45),
      height: rem(2),
      marginTop: theme.spacing.lg,
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: theme.spacing.lg,
    },
  },
}));

export default function Title({ title, description, sx }: Props) {
  const { classes } = useStyles();

  return (
    <Container sx={sx}>
      <MantineTitle order={2} className={classes.title} ta="center" mt="sm">
        {title}
      </MantineTitle>

      <Text c="dimmed" className={classes.description} ta="center" mt="md">
        {description}
      </Text>
    </Container>
  );
}
